import apiClient from '@/lib/apiClient';
import type { ApiResponse } from '@/lib/apiClient';
import { toOracleDate } from '@/lib/dateUtils';
import type { Account, AccountService, AccountBalanceDetail, AccountType } from './types';

export async function fetchAccountInfo(idAccount: string): Promise<Account> {
  const { data } = await apiClient.get<ApiResponse<Account[]>>(`/api/accounts/${idAccount}`);
  const account = data.response?.[0];
  if (!data.success || !account) throw new Error('Аккаунт не найден');
  return account;
}

export async function fetchAccountServices(idAccount: string): Promise<AccountService[]> {
  const { data } = await apiClient.get<ApiResponse<AccountService[]>>(
    `/api/accounts/${idAccount}/cameras`
  );
  if (!data.success) throw new Error('Не удалось загрузить услуги');
  return data.response ?? [];
}

export async function fetchAccountBalanceDetail(
  idAccount: string,
  dateStart: string,
  dateEnd: string
): Promise<AccountBalanceDetail[]> {
  const { data } = await apiClient.get<ApiResponse<AccountBalanceDetail[]>>(
    `/api/accounts/${idAccount}/balance/detail`,
    { params: { date_start: toOracleDate(dateStart), date_end: toOracleDate(dateEnd) } }
  );
  if (!data.success) throw new Error('Не удалось загрузить детализацию');
  return data.response ?? [];
}

export async function fetchAccountTypes(): Promise<AccountType[]> {
  const { data } = await apiClient.get<ApiResponse<AccountType[]>>('/api/accounts/types');
  if (!data.success) throw new Error('Не удалось загрузить типы аккаунтов');
  return data.response ?? [];
}
